import { Epic, ofType } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { Action } from '../actions';
import { REQUEST_CLIENT_MOBILE_APPS_DATA, updateClientMobileAppsData } from '../actions/clientMobileAppsData';
import { showCommonDataFetchError } from '../actions/common';
import { ApiMethodExecutingError } from '../service/Errors';
import { EpicDeps } from '../service/StoreFactory';
import { ClientMobileAppsData, State } from '../typings/state';

export const requestClientMobileAppsDataEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) =>
    action$.pipe(
        ofType(REQUEST_CLIENT_MOBILE_APPS_DATA),
        mergeMap(
            (): Observable<Action> => {
                const { authorizationData } = store$.value.commonData;
                const ulogin = store$.value.commonData.login;

                const currentOperator = ulogin || (authorizationData ? authorizationData.login : '');

                return from(deps.commonDataProvider.fetchClientMobileApps(currentOperator)).pipe(
                    mergeMap(
                        (clientMobileAppsData: ClientMobileAppsData): Observable<Action> => {
                            return of(updateClientMobileAppsData(clientMobileAppsData));
                        }
                    ),
                    catchError(
                        (err: ApiMethodExecutingError): Observable<Action> => {
                            return of(showCommonDataFetchError(err));
                        }
                    )
                );
            }
        )
    );
